import SimpleCrypto from 'simple-crypto-js'

let _secretKey = 'login-unique-key'
let simpleCrypto = new SimpleCrypto(_secretKey)

export default simpleCrypto
